export const ColorEstrategia = (nivel: string) => {
    switch (nivel) {
        case "1":
            return '#FF7F41'
        case "2.1":
            return '#9063CD'
        case "2.2":
            return '#59CBE8'
        case "3":
            return '#00C389'
    }
}



export const Estrategias = [
    {name: "Agro", level: "2.1", score: "84%" , x: -200, y: 300},
    {name: "Origenes", level: "1", score: "100%" , x: -5, y: 120},
    {name: "Sostenibilidad", level: "1", score: "93%" , x: -5, y: 190},
    {name: "Nomina", level: "2.1", score: "81%" , x: -200, y: 300},
    {name: "Encadenamientos Productivos", level: "3", score: "68%" , x: -130, y: 750},
    {name: "Ciclo de negocio", level: "3", score: "67%" , x: -250, y: 800},
    {name: "Bolsillos", level: "3" , score: "68%", x: 120, y: 750},
    {name: "Bancolombia a la mano", level: "2.2" , score: "72%", x: 0, y: 620},
    {name: "Generación Consiente", level: "2.1", score: "84%" , x: 170, y: 300},
    {name: "Gobierno", level: "3", score: "68%" , x: 300, y: 750},
    {name: "Pricing", level: "2.1" , score: "84%", x: -40, y: 300},
    {name: "Educación Financiera", level: "2.1", score: "75%" , x: 100, y: 400},
    {name: "Tu360 Vivienda", level: "2.1", score: "75%" , x: -150, y: 400},
    {name: "Pagos", level: "2.2" , score: "72%", x: -70, y: 520},
    {name: "Pyme", level: "2.2", score: "73%" , x:100, y: 520},
    {name: "Plus Alto", level: "2.1", score: "88%" , x: -200, y: 300},
    {name: "Preferencial y Privada", level: "2.1" , score: "84%", x: -300, y: 350},
    {name: "Tu360 Movilidad", level: "2.2", score: "71%" , x: -250, y: 520},
    {name: "Tu360 Compras", level: "2.1", score: "78%" , x: 220, y: 350},
    {name: "Endeudamiento Responsable", level: "2.2", score: "71%" , x: -300, y: 570},
    {name: "Fidelización", level: "3", score: "59%" , x: 480, y: 750},
    {name: "Recaudos y Pagos de facturas", level: "3" , score: "65%", x: -450, y: 750},
    {name: "Fútbol", level: "2.2", score: "72%" ,x: -60, y: 570},
    {name: "Independientes", level: "2.2", score: "71%" ,x: 120, y: 570},
    {name: "Movilidad Publica", level: "2.2", score: "70%" ,x: 370, y: 570},
    {name: "Aceptación Comercios", level: "2.1" , score: "78%",x: -30, y: 350},
    {name: "Adopción y Direccionamiento", level: "2.2", score: "72%" ,x: -300, y: 620},
    {name: "Inversiones", level: "3" , score: "65%",x: 250, y: 800},
    {name: "Puntos Colombia", level: "3", score: "46%" ,x: 200, y: 850},
    {name: "Grupo Bancolombia Capital", level: "3" , score: "46%",x: 500, y: 800},
    {name: "Impuestos", level: "3" , score: "67%",x: -450, y: 800},
    {name: "Sucursal Virtual Negocios", level: "3" , score: "57%",x: 20, y: 800},
    {name: "Día a Día", level: "3", score: "50%" ,x: 500, y: 850},
    {name: "Remesas", level: "3", score: "68%" ,x: 200, y: 850},
    {name: "Ofertas y Alianzas", level: "3", score: "65%" ,x: 200, y: 850},
    {name: "Colombianos en el exterior", level: "3" , score: "59%",x: 200, y: 850},
    {name: "Comercio internacional", level: "3" , score: "58%",x: 200, y: 850},
    {name: "Seguros", level: "2.2" , score: "72%",x: 300, y: 520},
    {name: "Gestion de activos LRU", level: "3", score: "56%" ,x: -100, y: 850},
    {name: "Diversidad", level: "3", score: "67%" ,x: -320, y: 850},
    {name: "Cultura", level: "3", score: "55%" ,x: -500, y: 850},
    {name: "Relacionamiento Corporativo", level: "2.2", score: "73%" ,x: 300, y: 620},
    {name: "Pensionados", level: "2.2", score: "73%" ,x: 0, y: 670}
    ]